module.exports = __webpack_public_path__ + "img/metrics--avatar.e572f31d.svg";